import styled from 'styled-components';

export const StyledEmptyNoteContent = styled.div`
   color: ${(props) => props.theme.borderDark};
`;

StyledEmptyNoteContent.displayName = 'StyledEmptyNoteContent';
